import React, { useState, useEffect } from 'react';
import Popup from "./Popup.tsx";
import NoteService from '../../services/NoteService';
import Accordion from './Accordion/Accordion';
import { FaInfoCircle } from 'react-icons/fa';
import useIsMobile from "../../utils/useIsMobile";

function NoteItem({ note, handleClick, handleStatusChange, statusValues }) {
  const [imageData, setImageData] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
    const togglePopup = () => {
    const hasPopupBeenShown = localStorage.getItem('popupShown');
    if (!hasPopupBeenShown && ((note.isDone && note.number === 15) || (note.isDone && note.number === 16))) {
      setPopupVisible(true);
      localStorage.setItem('popupShown', 'true');
    } else {
      setPopupVisible(false);
    }
  };
    const isMobile = useIsMobile(); // default breakpoint is 550px

    useEffect(() => {
    togglePopup();
  }, []);

    useEffect(() => {
    togglePopup();
  }, [note.isDone, note.number]);

  const handleExpandClick = async (parameter) => {
        const { number } = note;
        if (imageData.length > 0) return; // Skip fetching if images are already loaded

        try {
            const imageDataArray = [];
            for (let index = 1; index <= 3; index++) {
                const imageResponse = await NoteService.getDescription(parameter, number.toString());
                const arrayBuffer = await imageResponse.data;
                const blob = new Blob([arrayBuffer]);
                imageDataArray.push(blob);
            }
            setImageData(imageDataArray);
        } catch (error) {
            console.error('Error fetching image:', error);
        }
    };

    const InfoA5 =
  "Här nedan ska du först läsa igenom varje delmoment innan du påbörjar med den. " +
      " Lämplig övningsplats lugn gata / industriområde eller en stor parkering eller annan lämplig plats utan några bilar eller trafikanter."
  const InfoA6 = "Lämplig övningsplats lugn gata / industriområde / landsväg  eller annan lämplig plats utan några bilar eller trafikanter."
  const InfoA7 = "I den här momentet ska din handledare och du prata igenom olika trafiksituationer utifrån beskrivnigen av delmoment som kommer neden och därefter ska ni öva på dessa delmoment. "
  const InfoA71 = "Lämplig övningsplats lugn gata / industriområde / landsväg  eller annan lämplig plats utan några bilar eller trafikanter."
  const InfoA15 = "Välj en trafikfri plats (villaområde eller liknande) där det finns god marginal mellan bilarna du ska parkera mellan , detta är för att du inte ska köra in i parkerade bilar."
  const InfoA16 = "Tala om högt om dina handlingar för din handledare om du känner dig bekväm att köra och prata samtidigt. På så sätt kan din handledare följa dina tankar och ha koll på dina handlingar och eventuella misstag. "
  const InfoA4 = "Tala högt om dina handlingar för din handledare om du känner dig bekväm att köra och prata samtidigt. På så sätt kan din handledare följa dina tankar och ha koll på dina handlingar och eventuella misstag. Om du inte känner dig bekväm med detta än träna på detta vid senare tillfällen. "
  // @ts-ignore

    const InfoB2 = " Med AVSTÄNGT motor, använd din fantasi och föreställ dig olika fall nedan. Använd pedaler och växellåda och testa att växla i följande fall: "


    const info2 =
        <>
        <h2 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}> Senare i år lanceras följande moment:</h2>
        <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>INLEDANDE TRAFIK<br/>STADSTRAFIK OCH LANDSVÄG<br/>AVANCERADE MOMENT</h1>
        </>
    return (
      <>



          {note.number === 8 ?  <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}> INLEDANDE TRAFIK </h1> : ''}
          {note.number === 10 ? <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>STADSTRAFIK OCH LANDSVÄG </h1> : ''}
          {note.number === 15 ? <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}> AVANCERADE MOMENT</h1> : ''}
        <div
            key={note.id}
            style={{ backgroundColor: '#f8f7f8', borderRadius: '5px' }}
            className={
              isMobile
                  ? note.isDone
                      ? 'is-done item p-8 mt-16 card'
                      : 'item p-8 mt-16 card'
                  : note.isDone
                      ? 'is-done item p-32 m-16 card'
                      : 'item p-32 m-16 card'
            }
        >
          {note.isDone === true ?  <> <h1>🏁</h1> <h1>  Klar ! </h1>  </>: ''}
          <div className='bg1 mb-16 p-8'>
            {note.isDone === false ? <> <h2>🏁</h2> <h3 className="pt-8 pb-8">  Klar med lektion? Kryssa i nedan </h3>  </>: ''}
            <input className="m-16 checkbox" type="checkbox" onChange={() => handleClick(note.id)} checked={note.isDone} />
          </div>
          <p> {note.number === 5 ?   InfoA4  : ''} </p>
         <p className={'pt-16'}> {note.number === 5 ?   InfoA5  : ''} </p>
          {note.number === 6 ?   InfoA6 : ''}
         <p>
           {note.number === 7 ?   InfoA7 : ''}
         </p>
          <p className={'pt-16'}>
           {note.number === 7 ?   InfoA71 : ''}
         </p>
          {note.number === 15 ?   InfoA15 : ''}
          {note.number === 16 ?   InfoA16 : ''}
          {note.catA && (
              <>
                <h3 className='p-16 pt-32'>{note.catA}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catA1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'1'}
                />

                <select
                    className='center'
                    value={note.statA || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statA')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                <div className='center mt-8' style={{ marginTop: "60px"}}/>
              </>
          )}
          {note.catB && (
              <>
                  <p className={'pt-16'}> {note.number === 3 ?
                  <>  <span className={'pb-16 custom-icon2 flex center'}> <FaInfoCircle/> </span>
                      <span> {InfoB2}</span> </>
                      : ''} </p>

                  <h3 className='p-16 pt-32'>{note.catB}</h3>
                  <Accordion
                      title={<h3>Instruktioner</h3>}
                      parameter={`catB1`}  // Ensure 'catB1' or a valid string is passed here
                      number={note.number.toString()}
                      onExpandClick={handleExpandClick}
                      imageData={imageData}
                      id={'3'}
                  />
                <select
                    className='center'
                    value={note.statB || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statB')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>

              </>
          )}
          {note.catC && (
              <>
                <h3 className='p-16 pt-32'>{note.catC}</h3>
                <Accordion
                    title={<h3>Instruktioner </h3>}
                    parameter={`catC1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'3'}
                />
                <select
                    className='center'
                    value={note.statC || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statC')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>

              </>
          )}
          {note.catD && (
              <>
                <h3 className='p-16 pt-32'>{note.catD}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catD1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'4'}
                />
                <select
                    className='center'
                    value={note.statD || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statD')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>
              </>
          )}
          {note.catE && (
              <>
                <h3 className='p-16 pt-16'>{note.catE}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catE1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'5'}
                />
                <select
                    className='center'
                    value={note.statE || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statE')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>
              </>
          )}
          {note.catF && (
              <>
                <h3 className='p-16'>{note.catF}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catF1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'6'}
                />
                <select
                    className='center'
                    value={note.statF || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statF')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>

              </>
          )}
          {note.catG && (
              <>
                <h3 className='p-16'>{note.catG}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catG1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'7'}
                />
                <select
                    className='center'
                  value={note.statG || ''}
                  onChange={(e) => handleStatusChange(e, note.id, 'statG')}
              >
                  <option value="">----Välj status----</option>
                {statusValues.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                ))}
              </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>
              </>
          )}
          {note.catH && (
              <>
                <h3 className='p-16'>{note.catH}</h3>
                <Accordion
                    title={<h3>Instruktioner</h3>}
                    parameter={`catH1`}
                    number={note.number.toString()}
                    onExpandClick={handleExpandClick}
                    imageData={imageData}
                    id={'8'}
                />
                <select
                    className='center'
                    value={note.statH || ''}
                    onChange={(e) => handleStatusChange(e, note.id, 'statH')}
                >
                  <option value="">----Välj status----</option>
                  {statusValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                  ))}
                </select>
                  <div className='center mt-8' style={{ marginTop: "60px"}}/>
              </>
          )}
            {note.catI && (
                <>
                    <h3 className='p-16'>{note.catI}</h3>
                    <Accordion
                        title={<h3>Instruktioner</h3>}
                        parameter={`catI1`}
                        number={note.number.toString()}
                        onExpandClick={handleExpandClick}
                        imageData={imageData}
                        id={'9'}
                    />
                    <select
                        className='center'
                        value={note.statI || ''}
                        onChange={(e) => handleStatusChange(e, note.id, 'statI')}
                    >
                        <option value="">----Välj status----</option>
                        {statusValues.map((value) => (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        ))}
                    </select>
                    <div className='center mt-8' style={{ marginTop: "60px"}}/>
                </>
            )}

        </div>

          {note.number === 5 ?   info2 : ''}
        <Popup
            isVisible={popupVisible}
            onClose={() => setPopupVisible(false)}
            onNavigate={() => {
              console.log("Navigating to /schools");
            }}
        />
      </>
  );
}
export default NoteItem;


